module.exports = __webpack_public_path__ + "static/media/1.6df33eda.jpg";